import type { IBaseAttributes, TConstraints } from '@feathr/rachis';
import { Collection, Model } from '@feathr/rachis';

/**
 * A global feature-flag registry entry.
 *
 * The backend document also carries `is_on` and `should_override`, deliberately omitted here.
 * Neither is read anywhere: gating resolves against the account's and user's own flag maps
 * (anhinga `has_required_flags`, shrike `useFlags`), and the global-default merge that once
 * consumed them was removed in 2020. Glassbox still displays and writes `is_on`, which is one of
 * the things Perch replaces — so a flag can read "on for all customers" there while being enabled
 * for a fraction of accounts. Modelling them would invite that claim back into Perch.
 */
export interface IFlag extends IBaseAttributes {
  name: string;
  is_archived: boolean;
}

export class Flag extends Model<IFlag> {
  public readonly className = 'Flag';

  public get constraints(): TConstraints<IFlag> {
    return {};
  }
}

export class Flags extends Collection<Flag> {
  public getClassName(): string {
    return 'flags';
  }

  /*
   * anhinga's /flags route in AuthBlueprint is registered without a trailing
   * slash (unlike every other list route in that blueprint). The default
   * rachis URL is `<host>flags/`, which Flask 404s and causes the CORS
   * preflight to fail. Override to drop the slash and match anhinga exactly.
   * See anhinga/auth/blueprint.py: `add_url_rule("/flags", ...)`.
   */
  public override url(): string {
    return `${this.getHostname()}flags`;
  }

  public getModel(attributes: Partial<IFlag>): Flag {
    return new Flag(attributes);
  }
}
